module.exports = {
  "title": "conversations",
  "sub_text": "track recipients' engagement",
  "search": {
    "placeholder": "Search for a share riiiiight here"
  },
  "all_viewers": "All viewers",
  "known_viewers": "Known viewers",
  "anonymous_viewers": "Anonymous viewers",
  "reshareMessage": {
    "reshare_with": "Reshared with",
    "from_message" : "{fromMessage} and {fromReshare} other contact(s)",
    "reshared_by": "Reshared by",
    "no_reshares": "No Reshares"
  },
  "sort_by": "Sort by",
  "no_recipients": "No Recipients Recorded",
  "dnd": "DND",
  "last_clicked": "Last clicked on a link on",
  "include_session": "Include session",
  "exclude_session": "Exclude session",
  "session_excluded": "This session has been excluded.",
  "actions": {
    "filter": {
      "all_viewers": "All Viewers",
      "known_viewers": "Known Viewers",
      "anonymous_viewers": "Anonymous Viewers"
    },
    "created_date": "Created Date",
    "last_activity": "Last Activity",
    "time_spent": "Time Spent"
  },
  "coversation_card": {
    "last_active": "Last active",
    "shared": "shared",
    "more": "more"
  },
  "detail_view": {
    "description": "You shared {assetsCount} assets with {recipientsCount} recipients",
    "no_subject": "(No Subject)",
    "to": "To",
    "cc": "Cc",
    "bcc": "Bcc",
    "via": "via",
    "time_stamp": "{lastActivityDate} ago via {channel}",
    "activity": {
      "title": "Here's how we are doing",
      "email_open_rate": "Email Open rate",
      "click_rate": "Link Click Rate",
      "time_spent": "Time spent",
      "deal_value": "Deal Value",
      "deal_stage": "Deal Stage"
    },
    "error_messages": {
      "no_activity": "We don't see any activity yet. But, we'll be on the lookout.",
      "no_activity_recorded": "No activity recorded",
      "bounced": "Bounced",
      "complained": "Complained",
      "not_delivered": "Not delivered",
      "dnd_not_delivered": "DND recipient not delivered"
    },
    "actions": {
      "add_deal": "Add Deal",
      "delete": "Delete",
      "view_timeline": "View Timeline",
      "preview": "Preview",
      "resend": "Resend",
      "recipients": {
        "title": "Recipients",
        "remove_access": "Remove Access",
        "grant_access": "Grant Access",
        "removing_access": "Removing Access",
        "granting_access": "Granting Access",
        "access_removed": "Access Removed",
        "exclude_session": "Exclude session"
      },
      "sort": {
        "title": "Sort by",
        "most_active": "Most active",
        "last_activity": "Last activity"
      },
      "show_less": "Show less",
      "edit_collection": "Edit Collection",
      "view_live_collection": "View Live Collection"

    },
    "asset_analytics": {
      "description": "You shared {assetName}. Here's the viewing pattern",
      "last_viewed": "Last Viewed",
      "time_spent": "Time Spent"
    },
    "sliders": {
      "map_deal": {
        "title": "map deals",
        "sub_text": "Pick the deal you want {emotionally} attached to this share.",
        "fetching": "Fetching opportunities",
        "enter_to_refresh": "Enter to refresh results",
        "search": {
          "placeholder": "Search opportunities",
          "actions": {
            "map_deal": "Map Deal"
          }
        }
      },
      "delete_conversation": {
        "title": "deleting",
        "description": "Are you sure you'd like to permanently delete this share?",
        "toast": {
          "message": "Success",
          "description": "Conversation deleted successfully"
        }
      },
      "timeline": {
        "title": "timeline",
        "sub_text": "You have shared {assetsCount} Assets with {recipientsCount} Recipients",
        "search": {
          "placeholder": "Search by recipient and asset"
        },
        "filter_by": "Filter by"
      },
      "resend": {
        "title": "Resend Conversation",
        "subject": "Subject",
        "error_messages": {
          "no_email": "We don’t see a recipient in the ‘To’ field. Add an email id.",
          "dnd_enabled": "One or more recipients have enabled DND and will not receive your email."
        }
      },
      "exclude_session": {
        "title": "exclude",
        "sub_text": "this session",
        "description": "This session will be excluded from your current, past and all future analytics across Conversations, Reports, Daily Digest and Asset Analytics. This will be an account level exclusion for ALL USERS in your organisation.",
        "note": "NOTE: By clicking on “Include”, you can choose to reverse this decision at any time."
      }
    }
  },
  "toast": {
    "exclude": "excluded visitor successfully",
    "include": "included visitor successfully"
  },
  "empty_message": {
    "title": "Uh oh, couldn't find what you're looking for...",
    "message": "The share you're looking for doesn't seem to exist. Don't worry, it takes 5 minutes and 23.7658 seconds to create one.",
    "actions": {
      "go_back": "Take me back home safe"
    }
  }
}